"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("../Theme/constant");

var _constants = require("./constants");

var _default = {
  PropTypes: {
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    isMobile: _propTypes.bool,
    show: _propTypes.bool,
    data: _propTypes.array,
    bigPoints: _propTypes.string,
    loyaltyTier: _propTypes.string,
    bigmemberId: _propTypes.string,
    isClosed: _propTypes.func,
    doLogout: _propTypes.func,
    overlayZIndex: _propTypes.string,
    PositionType: _propTypes.string,
    containerZIndex: _propTypes.string,
    containerWidth: _propTypes.string,
    bottomSheetZIndex: _propTypes.string,
    showBigLoyaltyPoints: _propTypes.bool,
    creditBalance: _propTypes.string,
    showCreditBalance: _propTypes.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    isMobile: false,
    accessible: true,
    show: false,
    PositionType: _constants.DEFAULT_STYLES.POSITION,
    overlayZIndex: _constants.DEFAULT_STYLES.OVERLAY_Z_INDEX,
    containerZIndex: _constants.DEFAULT_STYLES.CONTAINER_Z_INDEX
  }
};
exports.default = _default;